import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import { useSelector} from "react-redux";
import {
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Cell,
    ResponsiveContainer,
    ZAxis,
    LineChart, ReferenceLine
} from 'recharts';
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';
import Typography from "@material-ui/core/Typography";

const colors = scaleOrdinal(schemeCategory10).range();


const useStyles = makeStyles(theme => ({
    mainGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
         //backgroundColor: '#434941'
    }
}));




const SlaHeatMapChart = (props) => {
    const classes = useStyles();

    const [left, setLeft] = useState("dataMin");
        const [right, setRight] = useState("dataMax");
        const [refAreaLeft, setRefAreaLeft] = useState("");
        const [refAreaRight, setRefAreaRight]= useState("");
        const [top, seTop] = useState("dataMax+1");
        const [bottom, setBottom] = useState("dataMin-1");
        const [top2, setTop2] = useState("dataMax+20");
        const [bottom2, setBottom2] = useState("dataMin-20");
        const [animation, setAnimation] = useState(true);



/*
    const zoom = () => {
        if (refAreaLeft === refAreaRight || refAreaRight === "") {
            setRefAreaLeft("");
            setRefAreaRight("")
            return;
        }

        // xAxis domain
        if (refAreaLeft > refAreaRight) {
            //[refAreaLeft, refAreaRight] = [refAreaRight, refAreaLeft];
            setRefAreaLeft(refAreaRight);
            setRefAreaRight(refAreaLeft);
        }

        // yAxis domain
        const [bottom, top] = getAxisYDomain(refAreaLeft, refAreaRight, "cost", 1);
        const [bottom2, top2] = getAxisYDomain(
            refAreaLeft,
            refAreaRight,
            "impression",
            50
        );


            setRefAreaLeft("");
            setRefAreaRight("");
            //data: data.slice(),
            setLeft(refAreaLeft);
            setRight(refAreaRight);
            //setBottom,
            //setTop,
            //setBottom2,
            //setTop2

    }
*/



    /*
    const getAxisYDomain = (from, to, ref, offset) => {
        const refData = data.slice(from - 1, to);
        let [bottom, top] = [refData[0][ref], refData[0][ref]];
        refData.forEach(d => {
            if (d[ref] > top) top = d[ref];
            if (d[ref] < bottom) bottom = d[ref];
        });

        return [(bottom | 0) - offset, (top | 0) + offset];
    };
*/



    if (props.series.length === 0) {
        return (<Typography>gerando informações...</Typography>)
    }

    const CustomTooltip = ({ active, payload, label }) => {
        console.log("customtooltip", active, payload, label);
        if (active && payload && payload.length ) {
            return (
                <div className="custom-tooltip">
                    <p className="label">{`OS: ${payload[0].payload.os.ordemServicoId}`}</p>
                    <p className="label">{`Chegada: ${payload[0].payload.os.DTChegada}`}</p>
                    <p className="label">{`Etapa atual: ${payload[0].payload.os.peDescricao}`}</p>
                    <p className="label">{`${payload[0].payload.os.Horas}horas de ${payload[0].payload.os.tempoHr}  (${Math.round(payload[0].payload.os.percentualDoSLA)}%)`}</p>

                </div>
            );
        }

        return null;
    };


    console.log("series", props.series);

    return (
      <React.Fragment>
          <ResponsiveContainer width="100%" height="100%">
              <ScatterChart
                  width={400}
                  height={400}
                  margin={{
                      top: 20,
                      right: 20,
                      bottom: 20,
                      left: 20,
                  }}
              >
                  <CartesianGrid />
                  <XAxis type="number" dataKey="x" name="horas" unit="h" />
                  <YAxis type="number" dataKey="y" name="SLA" unit="%" />
                  <Tooltip  content={<CustomTooltip />}/>
                  <ReferenceLine y={100} label="100% SLA" stroke="red" />


                  {
                      props.series.map((entry, index) => {
                 //         console.log("scatter.series.map", index, entry);
                          return ( <Scatter key={index} name={index} data={entry} fill={colors[index % colors.length]} />);
                      })
                  }

              </ScatterChart>
          </ResponsiveContainer>
      </React.Fragment>
    );

}

export default (SlaHeatMapChart)
